
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import GAService from '@/services/ga.service';
import { AsOf, AsOfType, AsOfData } from '../../store/types';
import moment from 'moment';

@Component({
  components: {
  },
})
export default class SaveAsProfileModal extends Vue {
  public asOfType: AsOfType = AsOfType.Relative;
  public profileName: string = '';
  public saveLoading: boolean = false;

  public get asOfDate(): Date {
    return this.$store.getters.getAsOfDate;
  }

  public get asOfRelative(): AsOfData {
    return this.$store.getters.getAsOfRelative;
  }

  public get asOfOptions(): object {
    const staticKey: string = moment(this.asOfDate).format('DD/MM/YYYY');
    const { count, unit }: AsOfData = this.asOfRelative;

    return {
      [staticKey]: AsOfType.Static,
      [`${count} ${unit}${count > 1 ? 's': ''} ago`]: AsOfType.Relative
    };
  }

  get profileToSave() {
    return this.$store.state.profiles.profileToSave;
  }

  get profiles() {
    return this.$store.state.profiles.profiles || [];
  }

  get profileNameExists() {
    if (this.profiles && this.profileToSave) {
      return this.profiles.find((profile: any) => {
        return profile.name === this.profileName;
      });
    }

    return false;
  }

  public closeModal() {
    this.$store.commit('setModal', '');
  }

  public async saveModal() {
    this.saveLoading = true;
    let asOf:AsOf = this.asOfType === AsOfType.Relative ?
      { type: AsOfType.Relative, data: this.asOfRelative } :
      { type: AsOfType.Static, data: this.asOfDate.toISOString().slice(0, 10) };

    const profile = { ...this.profileToSave, asOf, name: this.profileName  };

    if (this.profileNameExists) {
      this.overwriteProfile();
    } else {
      try {
        GAService.sendEvent(this.$gtag, 'Profile', 'Saved', profile.name);
        await this.$store.dispatch('saveProfile', profile);
        this.$store.commit('setToastSuccess', 'Profile saved!');
        this.closeModal();
        this.saveLoading = false;
      } catch (e) {
        this.$store.commit('setToastError', 'Error saving profile');
        this.saveLoading = false;
      }
    }
  }

  public async overwriteProfile() {
    try {
      GAService.sendEvent(this.$gtag, 'Profile', 'Overwritten', this.profileToSave.name);
      await this.$store.dispatch('replaceProfile', this.profileToSave);
      this.$store.commit('setToastSuccess', 'Profile saved!');
      this.closeModal();
      this.saveLoading = false;
    } catch (e) {
      this.$store.commit('setToastError', 'Error saving profile');
      this.saveLoading = false;
    }
  }

  public mounted() {
    if (!!this.profileToSave.name) {
      this.profileName = this.profileToSave.name;
    }

    const asOf: AsOf = this.$store.getters.getAsOf;
    this.asOfType = asOf.type;
  }

}

